import React, { ReactNode } from "react";

export interface AuditDialogProps {
  component: () => React.ReactNode;
}

export function AuditDialog(props: AuditDialogProps) {
  return (
    <div className="">
      <div className="w-full flex items-end justify-end">
      </div>
      <div className="">{props.component()}</div>
    </div>
  );
}
